module.exports = __webpack_public_path__ + "static/media/gcdef_10061.15fde924.ico";